<template>
  <div>
    <template v-if="communityKind === 'RuleCreator'">
      <CommunityRules :edit="editor"
                      v-on:update:query="query = $event"
                      @confirm="confirm()" :nonempty="nonempty"></CommunityRules>
    </template>
    <template v-else-if="communityKind === 'VennDiagram'">
      <ExistingCommunities :edit="editor"
                           v-on:update:query="query = $event"
                           @confirm="confirm()">
      </ExistingCommunities>
    </template>
    <template v-else-if="communityKind === 'CSVUpload'">
      <v-card>
        <v-card-text>
          Editing communities made of list of users is currently
          unavailable.
        </v-card-text>
        <v-card-actions>
          <v-btn @click="cancel()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </template>
    <template v-else>
      <CommunityQueryEditor v-model="query" @confirm="confirm()" />
    </template>
  </div>
</template>

<script>
    import {store} from "../../store/store";

    import CommunityRules from "./CommunityRules"
    import ExistingCommunities from "./ExistingCommunities"
    import CommunityQueryEditor from "./CommunityQueryEditor"

    export default {
        name: "EditCommunity",
        props: {"value": String, "kind": String, "nonempty": Boolean},
        components: { CommunityRules, ExistingCommunities, CommunityQueryEditor },
        data: vm => ({
            query: "",
            key: null,
            communityKind: vm.kind,
            editor: null
        }),
        methods: {
            confirm () {
                this.$emit("input", this.query)
                this.$emit("confirm", this.query)
            },
            cancel () {
                this.$emit("cancel")
            },
            update () {
                if (this.query !== null && this.query !== "") {
                    store.dispatch('getCommunityVE', this.query).then(ve => {
                        this.communityKind = ve.kind
                        this.editor = ve.value
                    })
                }
            }
        },
        mounted () {
            this.query = this.value
            this.update()
        },
        watch: {
            kind (val) {
                if (this.value === "" || this.value === null) {
                    this.communityKind = this.kind
                }
            },
            /* query (val) { */
                /* this.$emit("input", this.query) */
            /* }, */
            value (val, oldVal) {
                if (val !== null && val !== "" && val !== oldVal) {
                    this.query = val
                    this.update()
                }
            },
        }
    }
</script>
